import { Component } from '@angular/core';

@Component({
  selector: 'ngx-categories',
  template: `<router-outlet></router-outlet>`,
})
export class CategoriesComponent {
}
